module.exports = __webpack_public_path__ + "static/format-output-2e7601d8907756c08b2f2585edd40c76.svg";